// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container___nqEa","container__image":"styles_container__image__K94ws","skeleton-animation":"styles_skeleton-animation__HfM8k"};